import 'babel-polyfill'
import validate from 'jquery-validation'

window.validate = validate



let popup = $('.popup')
let popupContent = $('.popup__content')
let popupOverflower = $('.popup__overflower')
let htmlMain = $('html')


$(document).ready(() => {

  $(document).trigger('dom-bind', document)

  jQuery.validator.addMethod("myEmail", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /(\w[-._\w]*\w@\w[-._\w]*\w\.\w{2,3})/.test(value)
  }, 'Incorect email.')

})


$(document).on('dom-bind', (e, context) => {
  let $context = $(context)


  let $forms = $context.find('.js-ajax-form')

  $forms.each((index, el) => {
    let validationRules = $(el).data('validation')

    $(el).validate({
      rules: validationRules,
      submitHandler(el) {
        var $form = $(el)
        // console.log($form.serialize())
        $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: $form.serialize()
        }).done(function (res) {
          // console.log(res)

          let inner = `<div class="popup-inner">
          <div class="popup-inner__close-popup
           popup-inner__close-popup--black js-close">
          <span>&times;</span>
          </div>
          <div class="popup-inner__text-content">
            <p class="popup-inner__title">
              ${res}
            </p>
          </div>
        </div>`
          asyncHandler(inner)


          el.reset()
          // console.log('success')
        }).fail(function () {
          el.reset()
          console.log('Error')
        })
      }
    })
  })


  let $jsLinks = $context.find('.js-ajax-link')
  $jsLinks.each((index, el) => {
    let $el = $(el)
    $el.on('click', () => {
      let $dataUrl = $el.data('href')

      $.ajax({
        url: $dataUrl,
        type: 'get'
      }).done(function (res) {
        asyncHandler(res)
      })
    })
  })

})


export function asyncHandler(res) {
  // let html = $(res)
  let popup1 = $('.popup')
  let popupContent1 = $('.popup__content')
  let popupOverflower1 = $('.popup__overflower')
  let htmlMain1 = $('html')
  popupContent1.html(res)
  popup1.css('display', 'block')
  htmlMain1.addClass('active')
  popupOverflower1.on('click', function () {
    popup1.css('display', 'none')
    popupContent1.html('')
    htmlMain1.removeClass('active')
  })
  $('.js-close').on('click', function () {
    popup1.css('display', 'none')
    popupContent1.html('')
    htmlMain1.removeClass('active')
  })
  $(document).trigger('dom-bind', '.popup__content')
}



// WEBPACK FOOTER //
// ./src/js/main.js